import styled from 'styled-components'

export const TimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 32px;
`

export const TimelineItem = styled.div`
  position: relative;
  padding-bottom: ${({ $last }) => ($last ? '0' : '24px')};
`

export const TimelineDot = styled.div`
  position: absolute;
  left: -26px;
  top: 4px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color || 'var(--color-brand-live)'};
  z-index: 1;
`

export const TimelineConnector = styled.div`
  position: absolute;
  left: -19px;
  top: 18px;
  bottom: 0;
  width: 2px;
  background-color: var(--vo-cloud);
`

export const TimelineContent = styled.div`
  padding: 0 0 0 12px;
`

export const TimelineHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const TimelineAction = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--vo-ink);
`

export const TimelineActor = styled.span`
  font-size: 13px;
  color: var(--vo-slate);
`

export const TimelineTimestamp = styled.span`
  font-size: 12px;
  color: var(--vo-slate);
  margin-left: auto;
`

export const TimelineExpandedContent = styled.div`
  margin-top: 8px;
  padding: 12px;
  background: var(--vo-mist);
  border-radius: var(--radius-md);
  font-size: 13px;
  color: var(--vo-slate);
  max-height: ${({ $visible }) => $visible ? '500px' : '0'};
  overflow: hidden;
  opacity: ${({ $visible }) => $visible ? 1 : 0};
  transition: max-height 0.3s ease, opacity 0.3s ease;
`

export const ExpandToggle = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
  font-size: 12px;
  color: var(--color-brand-live);

  &:hover {
    text-decoration: underline;
  }
`

export const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: var(--vo-slate);
  font-size: 14px;
`
